<mat-card class="pageWrapper">
    <mat-card-content>
        <div class="mat-elevation-z8 section-wrap">
            <div class="page-title-wrap">
                <h2 class="page-title">
                    Add New File Name
                </h2>
            </div>
            <div class="form-wrap">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Enter Name of the file</mat-label>
                    <input matInput [(ngModel)]="fileName" name="fileName">
                </mat-form-field>
                <button mat-raised-button class="button-style" (click)="addFileName()">Submit</button>
            </div>
        </div>
    </mat-card-content>
</mat-card>